import { match, P } from "ts-pattern";
import { ClientActionFunction } from "react-router";

export function getIntent(requestData: unknown): string | null {
  if (
    requestData &&
    typeof requestData === "object" &&
    Object.hasOwn(requestData, "intent") &&
    typeof (requestData as Record<string, any>).intent === "string"
  ) {
    return (requestData as Record<string, any>).intent;
  }
  return null;
}

export function dispatchIntent<TIntent extends string = string>(body: unknown) {
  const m = match(body);

  function makeIntentWrapper(m: any) {
    return {
      handle<const T extends Record<string, any>>(
        intent: TIntent,
        pattern: T,
        fn: (args: P.infer<T> & { intent: TIntent }) => ReturnType<ClientActionFunction>
      ) {
        return makeIntentWrapper(m.with({ intent, ...pattern }, fn));
      },

      async run() {
        return m.otherwise(() => {
          throw Error("Unknown Intent");
        });
      },
    };
  }

  return makeIntentWrapper(m);
}
